import * as React from "react";

import PageDisplayProvider from "#data-access/page-display-provider.tsx";
import SiteHeader from "#page-package/site-header.tsx";
import SiteBanners from "#site-banners/site-banners.tsx";

/**
 * The header component for the app.
 */
export const Header = () => (
    <PageDisplayProvider>
        {({header, headerBackgroundColor, stickyHeader}) => {
            if (!header) {
                return null;
            }
            return (
                <>
                    <SiteBanners />
                    <SiteHeader
                        backgroundColor={headerBackgroundColor}
                        sticky={stickyHeader}
                    />
                </>
            );
        }}
    </PageDisplayProvider>
);
